// extracted by css-extract-rspack-plugin
export default {"exit":"pOlklg"};